import { render, staticRenderFns } from "./RemoveDiscipleModal.vue?vue&type=template&id=3771beda&"
import script from "./RemoveDiscipleModal.vue?vue&type=script&lang=js&"
export * from "./RemoveDiscipleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports